import { render, staticRenderFns } from "./input-cover-image.vue?vue&type=template&id=21faec98&scoped=true&"
import script from "./input-cover-image.vue?vue&type=script&lang=js&"
export * from "./input-cover-image.vue?vue&type=script&lang=js&"
import style0 from "./input-cover-image.vue?vue&type=style&index=0&id=21faec98&lang=scss&scoped=true&"
import style1 from "./input-cover-image.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21faec98",
  null
  
)

export default component.exports